import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useEditLineCrossingsStore } from "./editLineCrossingsStore/editLineCrossingsStore";
import { useNavigate } from "react-router-dom";

export const DeleteLineCrossingDialog = () => {
  const navigate = useNavigate();

  const {
    deleteLineCrossingDialogOpen,
    setDeleteLineCrossingDialogOpen,
    setLineToDeleteId,
    handleDeleteLineCrossing,
    setPageLoading,
  } = useEditLineCrossingsStore();

  return (
    <Dialog open={deleteLineCrossingDialogOpen}>
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete this line crossing?
      </DialogTitle>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setLineToDeleteId(null);
            setDeleteLineCrossingDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setPageLoading(true);
            handleDeleteLineCrossing(navigate);
          }}
          text="Delete"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
